module.exports = __webpack_public_path__ + "img/role1.95fb846d.png";